export const otherRouter = [
  {
    path: "scan-code-login",
    name: "scan-code-login",
    component: () => import("@/views/scan-code-login/scan-code-login.vue"),
    meta: {
      title: "扫码登录"
    }
  },
  {
    path: "url-scheme",
    name: "url-scheme",
    component: () => import("@/views/wx-link/url-scheme.vue"),
    meta: {
      title: "微信小程序跳转"
    }
  },
  {
    path: "file-collection",
    name: "file-collection",
    component: () => import("@/views/file-collection/file-collection.vue"),
    meta: {
      title: "文件合集",
      noCache: true
    }
  },
  {
    path: "answer-analysis",
    name: "answer-analysis",
    component: () => import("@/views/check-answers/answer-analysis.vue"),
    meta: {
      title: "查看答案解析",
      noCache: true
    }
  }
];
